export function phoneValidate(value) {
  const phoneRegex = /^01[0-9]{8,9}$/;
  if (!phoneRegex.test(value)) {
    return true;
  }
  return false;
}
